// @flow

import { hpfetch } from '../util';
import type { wantedType } from '../../types';
import type {
  djangoModelApiResponse,
  wrappedApiResponseType,
} from '../apiTypes';
import { addInstanceType } from '../../library/hitchpin_card/hitchpinCardFunctions';
import { CardInstanceType } from '../../components/Shared/HitchpinCard/CardInstanceType';

export const getSingle = (
  id: number,
): Promise<wrappedApiResponseType<wantedType>> =>
  hpfetch(`wanteds/mine/${id}/`);

export const getMany = (
  limit: number = 100,
  offset: number = 0,
): djangoModelApiResponse<wantedType> => {
  return hpfetch(
    `wanteds/mine/?limit=${limit}&offset=${offset}`,
  ).then(response =>
    addInstanceType(response, CardInstanceType.MyWantedListing),
  );
};
